import { State } from "./state";
import { MutationTree } from "vuex";
import {
  IS_LOADING,
  SET_ERROR,
  SET_SUCCESS,
  SET_DATA_ITEM,
  SET_DATA_LIST,
  SET_TOTAL,
  SET_DATA_ITEM_LOADING,
  SET_DATA_ID,
} from "@/store/Crud/functions/mutations";
import { SET_TUEV_SYSTEMS, SET_TUEV_STUDENTS } from "./types";

export default <MutationTree<State>>{
  IS_LOADING,
  SET_ERROR,
  SET_SUCCESS,
  SET_DATA_ITEM,
  SET_DATA_LIST,
  SET_TOTAL,
  SET_DATA_ID,
  SET_DATA_ITEM_LOADING,
  [SET_TUEV_SYSTEMS](state: State, systemsList: any) {
    // 1. Assign the incoming data (systemsList) to the state property (tuev_systems)
    state.tuev_systems = systemsList;

    // You can remove Object.assign, direct assignment is clearer here.
  },

  [SET_TUEV_STUDENTS](state: State, list: any[]) {
    state.tuev_students = Array.isArray(list) ? list : [];
  },
};
